<template>
  <div class="centerx" style="min-width: 1000px;">
	<vs-popup :active.sync="isPopupActive" title="Liste des documents:">
		<div>
			<vs-table stripe
			:data="contract_documents"
			class="mt-4"
			pagination
			:max-items="20"
			>
			<template slot="thead">
				<vs-th class="bgcolor white-txt" style="width: 200px;">Date</vs-th>
				<vs-th class="bgcolor white-txt"><div style="text-align: center; width: 100%;">Utilisateur</div></vs-th>
				<vs-th class="bgcolor white-txt">Type</vs-th>
				<vs-th class="bgcolor white-txt">Nom du fichier</vs-th>
				<vs-th class="bgcolor white-txt"><vs-spacer />Lien<vs-spacer /></vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="index" v-for="(row, index) in data">
				<vs-td>{{ row.creation_date.substr(0, 10).split("-").reverse().join("/") }}</vs-td>
				<vs-td>
					<vx-tooltip
					:text="row.firstname + ' ' + row.lastname"
					position="top"
					style="text-align: center;"
					>
					<vs-avatar
						style="border: 1px solid;"
						:text="row.firstname + ' ' + row.lastname"
						:src="getCollaboratorAvatar(row.user_id)"
					/>
					</vx-tooltip>
				</vs-td>
				<vs-td>{{ row.type_name }}</vs-td>
				<vs-td>{{ row.filename }}</vs-td>
				<vs-td>
					<vx-tooltip :text="row.link" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
						<a :href="row.link" target="_blank">
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-external-link"
								@click="() => {pass;}"
							></vs-button>
						</a>
					</vx-tooltip>
				</vs-td>
				</vs-tr>
			</template>
			</vs-table>
		</div>
	</vs-popup>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";

export default {
	name: "ContractDocumentsListTable",
	components: {
	},
	props: {
		contract_id: Number,
		contract_documents: Array,
		popupActive: Boolean
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			isPopupActive: this.popupActive
		};
	},
	created() {
		store.dispatch("getAllContractsDocumentsTypes");
	},
	watch: {
		popupActive: function(){
			this.isPopupActive = this.popupActive;
		},
	},
	methods: {
		getName(userId){
			let foundUser = this.allCollaborators.findIndex(row => row.id == userId);
			if(foundUser >= 0){
				return this.allCollaborators[foundUser].firstname.replace(/^\S/, s => s.toUpperCase()) + " " + this.allCollaborators[foundUser].lastname.toUpperCase();
			}
			else{
				return " ";
			}
		},
		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},
	}
};
</script>

<style scoped>
</style>
